export default function getProductId(hotelsInfo, deal) {
  if (deal.selectedDepartureId === null) {
    return hotelsInfo.map(({ id }) => id).toString();
  }

  return `deal_${deal.value.id}`;
}
